import React, { useState, useEffect } from 'react';

export default function ListMessagesModal({ open, onClose, node, onSave }) {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    buttonText: 'View Options',
    items: [
      { title: 'Option 1', description: 'Description for option 1', id: '1' },
      { title: 'Option 2', description: 'Description for option 2', id: '2' }
    ],
    maxItems: 10,
    delay: 0
  });
  const [newItem, setNewItem] = useState({ title: '', description: '' });

  useEffect(() => {
    if (open && node) {
      setFormData({
        title: node.data.title || '',
        description: node.data.description || '',
        buttonText: node.data.buttonText || 'View Options',
        items: node.data.items || [
          { title: 'Option 1', description: 'Description for option 1', id: '1' },
          { title: 'Option 2', description: 'Description for option 2', id: '2' }
        ],
        maxItems: node.data.maxItems || 10,
        delay: node.data.delay || 0
      });
    }
  }, [open, node]);

  const handleSave = () => {
    if (onSave) {
      onSave(node.id, formData);
    }
    onClose();
  };

  const addItem = () => {
    if (newItem.title.trim() && formData.items.length < formData.maxItems) {
      const itemId = (formData.items.length + 1).toString();
      setFormData(prev => ({
        ...prev,
        items: [...prev.items, { ...newItem, id: itemId }]
      }));
      setNewItem({ title: '', description: '' });
    }
  };

  const removeItem = (index) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };

  const updateItem = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.map((item, i) => 
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  if (!open) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  const contentStyle = {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    minWidth: '500px',
    maxWidth: '600px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  };

  const inputStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '8px 12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none'
  };

  const textareaStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none',
    minHeight: '60px',
    resize: 'vertical',
    fontFamily: 'inherit'
  };

  const buttonStyle = {
    background: '#007bff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    marginRight: '8px'
  };

  const secondaryButtonStyle = {
    background: '#6c757d',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer'
  };

  const smallButtonStyle = {
    background: '#dc3545',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '4px 8px',
    fontSize: '12px',
    cursor: 'pointer'
  };

  const itemStyle = {
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '12px',
    marginBottom: '8px',
    background: '#f8f9fa'
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={contentStyle} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: '#495057', fontSize: '20px', fontWeight: '600' }}>
            Configure List Message
          </h2>
        </div>

        {/* List Title */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            List Title
          </label>
          <input
            type="text"
            value={formData.title}
            onChange={e => setFormData(prev => ({ ...prev, title: e.target.value }))}
            placeholder="Enter list title..."
            style={inputStyle}
          />
        </div>

        {/* List Description */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            List Description
          </label>
          <textarea
            value={formData.description}
            onChange={e => setFormData(prev => ({ ...prev, description: e.target.value }))}
            placeholder="Enter list description..."
            style={textareaStyle}
          />
        </div>

        {/* Button Text */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Button Text
          </label>
          <input
            type="text"
            value={formData.buttonText}
            onChange={e => setFormData(prev => ({ ...prev, buttonText: e.target.value }))}
            placeholder="Enter button text..."
            style={inputStyle}
          />
        </div>

        {/* List Items Configuration */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            List Items ({formData.items.length}/{formData.maxItems})
          </label>
          
          {formData.items.map((item, index) => (
            <div key={index} style={itemStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '14px', fontWeight: '500', color: '#495057' }}>
                  Item {index + 1}
                </span>
                <button
                  onClick={() => removeItem(index)}
                  style={smallButtonStyle}
                >
                  ✕ Remove
                </button>
              </div>
              
              <input
                type="text"
                value={item.title}
                onChange={e => updateItem(index, 'title', e.target.value)}
                placeholder="Item title"
                style={{ ...inputStyle, marginBottom: '8px' }}
              />
              
              <textarea
                value={item.description}
                onChange={e => updateItem(index, 'description', e.target.value)}
                placeholder="Item description"
                style={{ ...textareaStyle, marginBottom: 0 }}
              />
            </div>
          ))}
          
          {formData.items.length < formData.maxItems && (
            <div style={{ border: '2px dashed #d1d5db', borderRadius: '4px', padding: '12px', marginTop: '12px' }}>
              <div style={{ marginBottom: '8px' }}>
                <input
                  type="text"
                  value={newItem.title}
                  onChange={e => setNewItem(prev => ({ ...prev, title: e.target.value }))}
                  placeholder="New item title"
                  style={{ ...inputStyle, marginBottom: '8px' }}
                />
                <textarea
                  value={newItem.description}
                  onChange={e => setNewItem(prev => ({ ...prev, description: e.target.value }))}
                  placeholder="New item description"
                  style={{ ...textareaStyle, marginBottom: '8px' }}
                />
              </div>
              <button
                onClick={addItem}
                style={buttonStyle}
                disabled={!newItem.title.trim()}
              >
                + Add Item
              </button>
            </div>
          )}
        </div>

        {/* Maximum Items Setting */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Maximum Items - {formData.maxItems}
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="range"
              min="1"
              max="20"
              value={formData.maxItems}
              onChange={e => setFormData(prev => ({ ...prev, maxItems: parseInt(e.target.value) }))}
              style={{ flex: 1 }}
            />
            <span style={{ fontSize: '14px', color: '#6c757d', minWidth: '30px' }}>
              {formData.maxItems}
            </span>
          </div>
        </div>

        {/* Delay Setting */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Delay before showing list - {formData.delay} sec
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="range"
              min="0"
              max="10"
              value={formData.delay}
              onChange={e => setFormData(prev => ({ ...prev, delay: parseInt(e.target.value) }))}
              style={{ flex: 1 }}
            />
            <span style={{ fontSize: '14px', color: '#6c757d', minWidth: '50px' }}>
              {formData.delay} sec
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button
            onClick={handleSave}
            style={{ ...buttonStyle, display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            💾 Save
          </button>
          <button
            onClick={onClose}
            style={{ ...secondaryButtonStyle, display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            ✕ Close
          </button>
        </div>
      </div>
    </div>
  );
} 